//激活html标签
var html5_tag = 'section,article,aside,header,footer,nav,dialog,figure',
    arr = html5_tag.split(',');
    
for (var i = arr.length; i--;) {
    document.createElement(arr[i]);
}



// WEBPACK FOOTER //
// ./js/base/html5.js